var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBlobRight = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226.356,
    height: 402.922,
    viewBox: "0 0 226.356 402.922",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#72a6a0",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    d: "M-661.164 299.3c2.713-8.186 5.7-17.465 8.975-27.967 1.944-6.233 3.846-11.872 5.7-16.965h-.364c31.643-87.179 79.384-81.494 126.53-150.985s0-137.718 55.734-187.626A102.724 102.724 0 0 1-436-102.366V299.3z",
    transform: "translate(661.856 103.121)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBlobRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/blob-right.1149204b.svg";
export { ForwardRef as ReactComponent };